let configPromise;

export function getRecaptchaConfig() {
  if (!configPromise) {
    const config = {
      v2SiteKey: process.env.REACT_APP_RECAPTCHA_V2_SITEKEY || process.env.REACT_APP_SITEKEY,
      v3SiteKey: process.env.REACT_APP_RECAPTCHA_V3_SITEKEY || process.env.REACT_APP_SITEKEY,
      action: process.env.REACT_APP_RECAPTCHA_V3_ACTION || 'validate_student_info'
    };

    configPromise = config.v2SiteKey && config.v3SiteKey
      ? Promise.resolve(config)
      : Promise.reject(new Error('Captcha site key is not configured'));
  }
  return configPromise;
}

export function resetRecaptchaConfig() {
  configPromise = undefined;
}
